import React, { useState, useContext } from 'react';
import { AuthContext } from '../App';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const LoginPage = () => {
  const { login } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post('/auth/login', { email, password });
      login(response.data.token, response.data.user);
      toast.success('Connexion réussie!');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-black px-4">
      <div className="w-full max-w-md">
        <div className="glass-panel p-8 animate-fadeIn">
          <div className="text-center mb-8">
            <img 
              src="/images/noodly-logo.png" 
              alt="Noodly" 
              className="h-16 mx-auto mb-4"
            />
            <h1 className="text-3xl font-bold mb-2 text-white" style={{fontFamily: 'Space Grotesk'}}>Pilote</h1>
            <p className="text-gray-400">Connectez-vous à votre compte</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
            <div>
              <Label htmlFor="email" className="text-white">Email</Label>
              <Input
                id="email"
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-2 bg-white/5 border-white/10 text-white"
                placeholder="votre@email.com"
                data-testid="login-email-input"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-white">Mot de passe</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-2 bg-white/5 border-white/10 text-white"
                placeholder="••••••••"
                data-testid="login-password-input"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#d03367] hover:bg-[#e04579] text-white font-medium py-6"
              data-testid="login-submit-button"
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-gray-400 text-sm">
              Pas encore de compte ?{' '}
              <Link to="/register" className="text-[#d03367] hover:text-[#e04579] font-medium">
                S'inscrire
              </Link>
            </p>
          </div>

          {/* Branding */}
          <div className="mt-8 text-center">
            <p className="text-gray-500 text-xs">
              Solution développée par <span className="text-white font-medium">BESSON SOLUTIONS</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
